import { useEffect, useRef } from "react";

export function useDisableBootstrap() {
  const bootstrapRef = useRef(null);

  useEffect(() => {
    const bootstrap = document.querySelector('link[href*="bootstrap"]');

    if (bootstrap) {
      bootstrapRef.current = bootstrap;
      bootstrap.remove();
    }

    return () => {
      if (bootstrapRef.current) {
        document.head.appendChild(bootstrapRef.current);
      }
    };
  }, []);
}
